export default "__VITE_ASSET__80c0eff8__"